export const Option = Object.freeze({
	// AhaMoments
	AhaResponsibleMany: 'aha_responsible_many',
	AhaTaskSettingsMessagePopup: 'aha_task_settings_message',
	AhaAuditorsInCompactFormPopup: 'aha_auditors_compact_form',
	AhaRequiredResultCreatorPopup: 'aha_required_result_creator',
	AhaRequiredResultResponsiblePopup: 'aha_required_result_responsible',
	AhaResultFromMessagePopup: 'aha_result_from_message',
	AhaStartTimeTracking: 'aha_start_time_tracking',
	AhaTaskChatPopup: 'aha_task_chat',
	AhaTaskImportantMessagesPopup: 'aha_task_important_messages',
	AhaTasksAiPromo: 'aha_tasks_ai_promo',
});
